/**
 * ヘッダー（.wl-header）内の予測検索のみ: PC幅で検索欄を折りたたみ、トグルで表示
 */
(function () {
  'use strict';

  /** @param {Element} el */
  function breakpointFor(el) {
    if (el.classList.contains('wl-header-search-field')) return 990;
    if (el.classList.contains('wl-header-search-top')) return 750;
    return null;
  }

  const initialized = new WeakSet();

  function keepHeaderVisible() {
    var stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader) return;
    stickyHeader.preventHide = true;
    var sectionHeader = document.querySelector('.section-header');
    if (sectionHeader && sectionHeader.classList.contains('shopify-section-header-hidden')) {
      requestAnimationFrame(function () {
        stickyHeader.reveal();
      });
    }
  }

  /** @param {Element} host */
  function setupPredictiveSearch(host) {
    if (!(host instanceof HTMLElement)) return;
    if (initialized.has(host)) return;

    const root = host.querySelector(
      '.wl-header-search.wl-header-search-top, .wl-header-search.wl-header-search-field',
    );
    if (!root) return;

    const bp = breakpointFor(root);
    if (!bp) return;

    const toggle = root.querySelector('.wl-header-search__desktop-toggle');
    const input = host.querySelector('input[type="search"]');
    if (!toggle || !input) return;

    initialized.add(host);

    const mq = window.matchMedia('(min-width: ' + bp + 'px)');

    function clearDesktopMode() {
      host.removeAttribute('data-wl-desktop-search');
      host.classList.remove('desktop-search-open');
      toggle.setAttribute('aria-expanded', 'false');
      var stickyHeader = document.querySelector('sticky-header');
      if (stickyHeader && !host.hasAttribute('open') && !host.isOpen) {
        stickyHeader.preventHide = false;
      }
    }

    function applyMq() {
      if (!mq.matches) {
        clearDesktopMode();
        return;
      }
      host.setAttribute('data-wl-desktop-search', String(bp));
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (!mq.matches) return;
      keepHeaderVisible();
      host.classList.add('desktop-search-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (typeof input.focus === 'function') {
        input.focus({ preventScroll: true });
      }
    });

    input.addEventListener('focus', function () {
      if (!mq.matches) return;
      keepHeaderVisible();
    });

    function syncSearchClosedState() {
      if (host.hasAttribute('open')) return;
      host.classList.remove('desktop-search-open');
      toggle.setAttribute('aria-expanded', 'false');
      var stickyHeader = document.querySelector('sticky-header');
      if (!stickyHeader) return;
      var anySearchOpen = stickyHeader.querySelector(
        'wl-predictive-search[open], wl-predictive-search.desktop-search-open',
      );
      if (!anySearchOpen) {
        stickyHeader.preventHide = false;
      }
    }

    const obs = new MutationObserver(syncSearchClosedState);
    obs.observe(host, { attributes: true, attributeFilter: ['open'] });

    mq.addEventListener('change', applyMq);
    applyMq();
  }

  function init() {
    document.querySelectorAll('.wl-header wl-predictive-search').forEach(function (el) {
      setupPredictiveSearch(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/**
 * --header-height: .section-header（テーマ他箇所用）
 * --wl-header-bottom: header.wl-header の下端（ビューポート座標）— オーバーレイ・予測検索の top
 * --wl-predictive-anchor-*: 開いている検索ボックスに合わせた横位置・幅
 */
(function syncHeaderLayoutCssVars() {
  var sectionResizeObserver = null;
  var headerResizeObserver = null;
  var predictiveObservers = [];
  var rafId = 0;
  var globalListenersAttached = false;

  function syncSectionHeaderHeight() {
    var el = document.querySelector('.section-header');
    if (!el) return;
    document.documentElement.style.setProperty('--header-height', el.offsetHeight + 'px');
  }

  function syncWlHeaderPredictivePosition() {
    var header = document.querySelector('header.wl-header');
    if (!header) {
      document.documentElement.style.removeProperty('--wl-header-bottom');
      document.documentElement.style.removeProperty('--wl-predictive-anchor-left');
      document.documentElement.style.removeProperty('--wl-predictive-anchor-width');
      return;
    }

    var hr = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--wl-header-bottom', hr.bottom + 'px');

    var openHost = header.querySelector('wl-predictive-search[open], wl-predictive-search[loading]');
    if (openHost) {
      var root = openHost.querySelector('.wl-header-search');
      if (root) {
        var sr = root.getBoundingClientRect();
        document.documentElement.style.setProperty('--wl-predictive-anchor-left', sr.left + 'px');
        document.documentElement.style.setProperty('--wl-predictive-anchor-width', sr.width + 'px');
      }
    } else {
      document.documentElement.style.removeProperty('--wl-predictive-anchor-left');
      document.documentElement.style.removeProperty('--wl-predictive-anchor-width');
    }
  }

  function scheduleSync() {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      syncSectionHeaderHeight();
      syncWlHeaderPredictivePosition();
    });
  }

  function attachPredictiveObservers() {
    predictiveObservers.forEach(function (o) {
      o.disconnect();
    });
    predictiveObservers.length = 0;

    var header = document.querySelector('header.wl-header');
    if (!header) return;

    header.querySelectorAll('wl-predictive-search').forEach(function (host) {
      var mo = new MutationObserver(scheduleSync);
      mo.observe(host, { attributes: true, attributeFilter: ['open', 'loading', 'results'] });
      predictiveObservers.push(mo);
    });
  }

  function attach() {
    var section = document.querySelector('.section-header');
    if (sectionResizeObserver) {
      sectionResizeObserver.disconnect();
    }
    if (section && typeof ResizeObserver !== 'undefined') {
      sectionResizeObserver = new ResizeObserver(scheduleSync);
      sectionResizeObserver.observe(section);
    }

    var header = document.querySelector('header.wl-header');
    if (headerResizeObserver) {
      headerResizeObserver.disconnect();
    }
    if (header && typeof ResizeObserver !== 'undefined') {
      headerResizeObserver = new ResizeObserver(scheduleSync);
      headerResizeObserver.observe(header);
    }

    attachPredictiveObservers();

    if (!globalListenersAttached) {
      window.addEventListener('scroll', scheduleSync, { passive: true, capture: true });
      window.addEventListener('resize', scheduleSync);
      globalListenersAttached = true;
    }

    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
  document.addEventListener('shopify:section:load', attach);
})();
